module.exports = __webpack_public_path__ + "static/media/googleplay.b26d765e.png";